import React from 'react';
import './Tests.css';
import ResultField from './ResultField/ResultField'

function Tests({tests}) {
 
  return (
    <div>
      <table className='tests__table'>
        <thead>
          <tr className='tests__tr'>
            <th className='tests__td' key='1'>Ввод</th>
            <th className='tests__td'key='2'>Правильный вывод</th>
            <th className='tests__td'key='3'>Ваш вывод</th>
            <th className='tests__td tests__td-time'key='4'>Временной лимит</th>
            <th className='tests__td tests__td-time'key='5'>Ваше время</th>
            <th className='tests__td'key='6'>Ошибка</th>
            <th className='tests__td'key='7'>Результат</th>
          </tr>
        </thead>
        <tbody>
          {tests.tests.map((item) => (
            <ResultField 
              key={item.id}
              item={item}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Tests;